import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ProtocolCardList.css';

const SYSTEM_ACCOUNT = "000000000000000000000000";

const getProtocolDuration = (timeline_days, t) => {
  if (!timeline_days || timeline_days.length === 0) return '—';
  const maxDay = Math.max(...timeline_days.map(d => d.end_day || d.start_day || 0));
  return `${maxDay} ${t('days')}`;
};

const ProtocolCard = ({ row, onEdit, actions, isIatf }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const isSystem = row.account === SYSTEM_ACCOUNT;
  const duration = getProtocolDuration(row.timeline_days, t);
  const targets = Array.isArray(row.target_animals) ? row.target_animals.join(', ') : row.target_animals || '—';
  const actionLabel = (id) => (actions || []).find(a => a._id === id)?.label || id;

  return (
    <div className={`protocol-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="protocol-card-main">
        <div className="protocol-card-name">{row.name || '—'}</div>
        <div className={`protocol-card-type ${isSystem ? 'system' : 'custom'}`}>
          {isSystem ? t('protocol_type_system') : t('protocol_type_custom')}
        </div>
        <div className="protocol-card-chevron">{expanded ? '▲' : '▼'}</div>
        <div className="protocol-card-secondary">
          <span>{duration}</span>
          <span>{targets}</span>
        </div>
      </div>

      {expanded && (
        <div className="protocol-card-detail" onClick={e => e.stopPropagation()}>
          {row.description && (
            <div className="protocol-card-detail-row">
              <span>{t('description')}</span><span>{row.description}</span>
            </div>
          )}
          {row.notes && (
            <div className="protocol-card-detail-row">
              <span>{t('notes')}</span><span>{row.notes}</span>
            </div>
          )}
          <div className="protocol-card-detail-row">
            <span>{t('duration')}</span><span>{duration}</span>
          </div>
          <div className="protocol-card-detail-row">
            <span>{t('target_animals')}</span><span>{targets}</span>
          </div>
          {row.timeline_days && row.timeline_days.length > 0 && (
            <div className="protocol-card-timeline">
              <div className="protocol-card-timeline-label">{t('timeline')}</div>
              {[...row.timeline_days].sort((a, b) => a.start_day - b.start_day).map((day, i) => (
                <div key={i} className="protocol-card-timeline-day">
                  <span className="protocol-card-day-num">
                    {t('day')} {day.start_day}{day.end_day !== day.start_day ? `–${day.end_day}` : ''}
                  </span>
                  <div className="protocol-card-day-detail">
                    {day.actions && day.actions.map((action, j) => (
                      <div key={j} className="protocol-card-day-event">{action}</div>
                    ))}
                    {day.action_ids && day.action_ids.map((id, j) => (
                      <div key={`a-${j}`} className="protocol-card-day-event">{actionLabel(id)}</div>
                    ))}
                    {day.note && (
                      <div className="protocol-card-day-note">{day.note}</div>
                    )}
                    {day.system_action && (
                      <div className="sa-tooltip-wrapper">
                        <div className="protocol-card-day-event system-action-badge">
                          <span>⚙️</span>
                          <span>{t(`system_action_${day.system_action}`)}</span>
                        </div>
                        <div className="sa-tooltip">
                          <span className="sa-tooltip-title">{t(`system_action_${day.system_action}_tooltip_title`)}</span>
                          <span className="sa-tooltip-body">{t(`system_action_${day.system_action}_tooltip`)}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          {!isSystem && (
            <div className="protocol-card-actions">
              <button className="edit-protocol-btn" onClick={() => onEdit(row)}>{t(isIatf ? 'edit_protocol' : 'edit_plan')}</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const ProtocolCardList = ({ data, onEdit, actions, isIatf = true }) => {
  return (
    <div className="protocol-card-list">
      {data && data.map(row => (
        <ProtocolCard key={row._id} row={row} onEdit={onEdit} actions={actions} isIatf={isIatf} />
      ))}
      {(!data || data.length === 0) && (
        <div className="protocol-card-empty">—</div>
      )}
    </div>
  );
};

export default ProtocolCardList;
